import type { DraftQuestion, GameDraft } from '../../../../shared/drafts';
import type { PublishedGame } from '../../../../shared/publications';
import { buildPrizeLadder } from '../../../../shared/billionaire';

export type BillionaireChoice = { id: string; label: string; correct: boolean; mediaUrl?: string };
export type BillionaireQuestion = {
  id: number;
  questionId: string;
  prompt: string;
  promptMediaUrl?: string;
  basePrize: number;
  choices: BillionaireChoice[];
};
export type BillionaireQuizConfig = { id: string; questions: BillionaireQuestion[] };
type Source = Pick<GameDraft | PublishedGame, 'id' | 'maxLevels' | 'questions'>;

function toQuestion(question: DraftQuestion, number: number, basePrize: number): BillionaireQuestion {
  return {
    id: number,
    questionId: question.id,
    prompt: question.prompt,
    promptMediaUrl: question.media?.url,
    basePrize,
    choices: question.choices.map((choice) => ({
      id: choice.id,
      label: choice.text,
      correct: choice.isCorrect,
      mediaUrl: choice.media?.url,
    })),
  };
}

export function draftToBillionaireQuizConfig(source: Source): BillionaireQuizConfig {
  const prizes = buildPrizeLadder(source.maxLevels);
  const questions = Array.from({ length: source.maxLevels }, (_, index) => {
    const number = index + 1;
    const question = source.questions.find((candidate) => candidate.levels[0] === number);
    if (!question) throw new Error(`${number}. yarışma sorusu bulunamadı.`);
    return toQuestion(question, number, prizes[index]);
  });
  return { id: source.id, questions };
}
